import Container from "@/components/common/Container";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

const NextLink = ({ nextImg, nextLink, nextTitle }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
  const handleMouseMove = ({ clientX, clientY }) => {
    if (isHovering) {
      setImagePosition({ x: clientX, y: clientY });
    }
  };

  return (
    <Container className="bg-primary-black">
      <div
        className="xl:flex justify-center items-center pt-16 pb-9 xl:pt-48 xl:pb-36"
        onMouseLeave={() => setIsHovering(false)}
      >
        <div
          className="xl:w-4/12 2xl:w-3/12"
          onMouseEnter={() => setIsHovering(false)}
        ></div>
        <div
          className="xl:w-4/12 2xl:w-3/12 text-center cursor-pointer font-medium"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          onMouseMove={handleMouseMove}
        >
          <Link passHref href={nextLink}>
            <a>
              <p className="cursor-pointer text-5xl xl:text-7xl xl:leading-tight text-white">
                <span dangerouslySetInnerHTML={{ __html: nextTitle }}></span>
              </p>
            </a>
          </Link>
          {isHovering && (
            <div
              className="fixed -translate-x-1/2 -translate-y-1/2 pointer-events-none scroll-smooth mix-blend-difference"
              style={{
                left: `${imagePosition.x}px`,
                top: `${imagePosition.y}px`,
              }}
            >
              <Image alt="casestudy" height={350} src={nextImg} width={350} />
            </div>
          )}
        </div>
        <div
          className="xl:w-4/12 2xl:w-3/12"
          onMouseEnter={() => setIsHovering(false)}
        ></div>
      </div>
    </Container>
  );
};

export default NextLink;
